import { Component, OnInit , ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ParkbewilligungenData, PbKategorieTyp } from '../parkbewilligungen-data';
import { PbKundenData } from '../../../providers/pbkunden-data';
import { UserData } from '../../../providers/user-data';
import { Components } from "../../../components";
import moment from 'moment';
import { CommonData } from '../../../providers/common-data';
/**
 * Generated class for the PbactionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbtermination',
  templateUrl: 'pbtermination.html',
})
export class PbTermination  {
  dEnd;  
  notifyCustomers: boolean = true;
  constructor(public navCtrl: NavController
            , public pbData: ParkbewilligungenData
            , public pbkData: PbKundenData
            , private _viewController: ViewController
            , private userData: UserData
            , public navParams:NavParams
            , public common: CommonData
    ) 
  {
    let d = moment();
    //d.add(1, "day");
    d.set({hour:23,minute:59,second:59,millisecond:59})
    this.dEnd = d.toISOString();    

  }

  close(){
    this._viewController.dismiss(null);
  }

  terminate(){
    this._viewController.dismiss({enddatum:this.dEnd, notifycustomers:this.notifyCustomers});
  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbtermination/pbtermination.ts